/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/Name
 * @desc ShowEdit for name for protocol value
 */

import { protocolValueFieldName } from 'labstep-web/components/ProtocolValue/Form/fields';
import { FormShowEditText as ShowEdit } from 'labstep-web/core/Form/ShowEdit/Text';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import type { IProtocolValueFormShowEditNameProps } from './types';

export const ProtocolValueFormShowEditName: React.FC<
  IProtocolValueFormShowEditNameProps
> = ({ protocolValue, options }) => (
  <ShowEdit
    dataCy="components/ProtocolValue/Form/ShowEdit/Name"
    entityName={protocolValue.entityName}
    entity={protocolValue}
    field={protocolValueFieldName}
    placeholder={`Untitled ${ProtocolValue.getHumanReadableEntityName(
      false,
      true,
    )}`}
    initialEditingState={!protocolValue.name}
    options={{ ...options }}
  >
    {protocolValue.name}
  </ShowEdit>
);
